import PATHS from 'src/router/paths'

const iconHome = require('src/assets/images/Home_64x64.png')
const iconDashboard = require('src/assets/images/Signal_64x64.png')
const iconDocs = require('src/assets/images/User_Docs_64x64.png')
const iconDocsPages = require('src/assets/images/User_Docs_Pages_64x64.png')

const iconTime = require('src/assets/images/Time_64x64.png')
const iconOrg = require('src/assets/images/Organization_64x64.png')
const iconPerson = require('src/assets/images/Person_64x64.png')
const iconProject = require('src/assets/images/Project_64x64.png')
const iconTimeRollup = require('src/assets/images/Overview_64x64.png')

const iconPacing = require('src/assets/images/Pacing_64x64.png')
const iconDiscrepancy = require('src/assets/images/Discrepancy_64x64.png')

const iconAlpha = require('src/assets/images/Alpha_64x64.png')
const iconProgrammatic = require('src/assets/images/Programmatic_64x64.png')
const iconNetworkHealth = require('src/assets/images/NetworkHealth_64x64.png')

const iconCustomAnalytics = require('src/assets/images/CustomAnalytic_64x64.png')

const icons = {
  navigation: {
    dashboard: iconDashboard,
    discrepancy: iconDiscrepancy,
    doc: iconDocsPages,
    docs: iconDocs,
    health: iconAlpha,
    home: iconHome,
    organization: iconOrg,
    [PATHS.INTERNAL.TIME_ROLLUP]: iconTimeRollup,
    pacing: iconPacing,
    [PATHS.PROGRAMMATIC.ADX_HEALTH]: iconAlpha,
    [PATHS.PROGRAMMATIC.NETWORK_HEALTH]: iconNetworkHealth,
    [PATHS.PROGRAMMATIC.ADX_AND_OPEN_BIDDING]: iconProgrammatic,
    person: iconPerson,
    programmatic: iconProgrammatic,
    project: iconProject,
    [PATHS.CUSTOM_ANALYTICS.BASE]: iconCustomAnalytics,
    [PATHS.INTERNAL.TIME_SHEET]: iconTime,

    add: {
      doc: iconDocsPages,
      docs: iconDocs,
      organization: iconOrg,
      [PATHS.INTERNAL.TIME_ROLLUP]: iconTime,
      [PATHS.PROGRAMMATIC.ADX_HEALTH]: iconAlpha,
      [PATHS.PROGRAMMATIC.NETWORK_HEALTH]: iconNetworkHealth,
      [PATHS.PROGRAMMATIC.ADX_AND_OPEN_BIDDING]: iconAlpha,
      person: iconPerson,
      project: iconProject,
      [PATHS.INTERNAL.TIME_SHEET]: iconTime,
    },
  },
  stateful: {
    defaults: {
      color: 'coolgray',
      icon: 'update',
    },
    error: {
      color: 'toasted',
      icon: 'update',
    },
    loading: {
      color: 'coolgray',
      icon: 'autorenew',
    },
    recovering: {
      color: 'toasted',
      icon: 'autorenew',
    },
    refreshing: {
      color: 'blue',
      icon: 'autorenew',
    },
    success: {
      color: 'offblue',
      icon: 'update',
    },
  },
  values: {
    false: {
      color: 'toasted',
      icon: 'indeterminate_check_box',
    },
    true: {
      color: 'offblue',
      icon: 'check_box',
    },
    'n/a': {
      color: 'midgray',
      icon: 'indeterminate_check_box',
    },
    null: {
      color: 'midgray',
      icon: 'check_box_outline_blank',
    },
    undefined: {
      color: 'midgray',
      icon: 'check_box_outline_blank',
    },
  },
}

export default icons
